












































import { useRouter, useStore } from '@/hooks/common'
import { MessageBox, Message, Tree } from '@heytap/cook-ui'
import { createComponent, ref, onMounted, watch, SetupContext, computed } from '@vue/composition-api'
import { gitDirList, IFileItem, loginInfo } from '../service/public'
import DuplicateNameConfirm, { StartCheckType } from './DuplicateNameConfirm.vue'
import { getRelationDirs, getDevAccount, UserInfo } from '@/service/public'
import { findIsManager } from '@/helpers/common'
import { isEmpty } from 'lodash'
interface CheckBoxType {
    startCheck: (obj: StartCheckType) => {}
}
function handleMove(setupContext: SetupContext) {
    const isShowCheckBox = ref(false)
    const store = useStore()
    const checkRef = ref<CheckBoxType>(void null)

    const handleDrop = (e: DragEvent, data) => {
        e.toElement.className = e.toElement.className.replace(' dragOver', '')
        const fileType = e.dataTransfer!.getData('fileType')
        if (fileType !== 'list') {
            return // 拖拽上传文件
        }
        e.stopPropagation()

        isShowCheckBox.value = true
        const list = JSON.parse(e.dataTransfer!.getData('fileList'))
        const currentDirId = setupContext.root.$route.query.id as string
        const target = data.data
        if (+target.id === 0) {
            Message.error('目标文件夹不能是根目录')
            return false
        }
        if (currentDirId === target.id) {
            Message.error('目标文件夹不能是当前文件夹')
            return false
        }
        checkRef.value.startCheck({ list, currentDirId, target })
    }

    const fileDragover = ev => {
        if (ev.target.className.indexOf('dragOver') === -1) {
            ev.target.className += ' dragOver'
        }
    }
    const fileDragLeave = ev => {
        ev.target.className = ev.target.className.replace(' dragOver', '')
    }
    const onMoveSuccess = async () => {
        await store.dispatch('publicStore/getTableData')
    }
    return {
        isShowCheckBox,
        checkRef,
        handleDrop,
        onMoveSuccess,
        fileDragover,
        fileDragLeave,
    }
}
export default createComponent({
    name: 'FoldTree',
    components: {
        DuplicateNameConfirm,
    },
    setup(props, setupContext) {
        const router = useRouter()
        const store = useStore()
        const newPathId = ref('')
        const isHighLight = ref(true)
        const foldTree = ref<Tree>()
        const defaultProps = {
            label: 'name',
            isLeaf: 'leaf',
        }
        const useHandleMove = handleMove(setupContext)
        const manageTopIds = ref<string[]>([])
        const isOnlySuperAdmin = ref<boolean>(false)
        const loadNode = async (node, resolve) => {
            // 恢复根目录确保对次级目录修改，tree和列表的同步更新
            if (node.level === 0) {
                // 确保拿到正确的isOnlySuperAdmin和manageTopIds 再渲染树
                const { code, data } = await loginInfo()
                if (code === 0) {
                    if (isEmpty(data.roles) && isEmpty(data.manageTopIds) && isEmpty(data.powerMap)) {
                        setupContext.root.$router.push('/noauthority')
                    }
                    manageTopIds.value = data.manageTopIds
                    isOnlySuperAdmin.value =
                        isEmpty(data.manageTopIds) &&
                        isEmpty(data.powerMap) &&
                        data.roles.length === 1 &&
                        data.roles[0] === 'FMS_ADMIN'
                    store.commit('SET_USER_DETAILS', data)
                }
                return resolve([
                    {
                        name: '根目录',
                        id: 0,
                        key: 0,
                        isFile: false,
                    },
                ])
            }
            const reqParams = {
                dirId: node.key || 0,
            }
            try {
                const currentDirData = await gitDirList(reqParams)
                if (currentDirData.data.length > 0) {
                    const res = (currentDirData.data as IFileItem[]).filter(item => {
                        if (isOnlySuperAdmin.value) {
                            item.leaf = true
                        }
                        if (findIsManager(manageTopIds.value, item.id)) {
                            item.isManager = true
                        }
                        return !item.isFile
                    })

                    return resolve(res)
                } else {
                    resolve([])
                }
            } catch (error) {
                resolve([])
            }
        }
        const synchro = async () => {
            const curretId = setupContext.root.$route.query.id
            if (!curretId || curretId === '0') {
                foldTree.value && foldTree.value.setCurrentKey('0')
                setTimeout(() => {
                    const currentDom = document.getElementsByClassName('custom-tree-node')[0]
                    currentDom && currentDom.scrollIntoView({ block: 'start', behavior: 'smooth' })
                }, 300)
                return
            }
            const res = await getRelationDirs(curretId)
            if (res && res.code === 0) {
                const AllData = res.data
                const fillTree = data => {
                    // 添加子节点
                    foldTree.value && foldTree.value.updateKeyChildren(data.id, data.children)
                    // 展开节点且设置loaded为true，避免再次展开的时候重复update数据
                    if (foldTree.value) {
                        foldTree.value.getNode(data.id).expanded = true
                        foldTree.value.getNode(data.id).loaded = true
                    }

                    // 递归
                    data.children.forEach(item => {
                        if (item.children) {
                            fillTree(item)
                        }
                    })
                }
                if (AllData && AllData.children) fillTree(AllData)
                // 设置leftTreeId保证tree在未点击node情况下刷新操作目录合起
                if (curretId !== store.state.publicStore.leftTreeId) {
                    store.commit('publicStore/SET_LEFT_TREE_ID', curretId)
                } else {
                    foldTree.value && foldTree.value.setCurrentKey(curretId)
                }
                // 增加延迟时间解决子文件过多无法定位到顶部
                setTimeout(() => {
                    const currentDom = document.getElementsByClassName('el-tree-node is-current')[0]
                    currentDom && currentDom.scrollIntoView(true)
                }, 500)
            }
        }

        const handleNodeClick = data => {
            // 点击只更新右侧列表，文件树不更新
            newPathId.value = data.id
            if (newPathId.value != setupContext.root.$route.query.id) {
                isHighLight.value = true
                store.commit('publicStore/SET_CURRENT_DIR_ID', data.id)
                store.commit('publicStore/SET_LEFT_TREE_ID', data.id)

                store.commit('publicStore/UPDATE_TABLE_DATA_CACHE')
                store.commit('publicStore/SET_IS_UPDATE_TREE', false)
                router.push({ path: '/', query: { id: data.id } })
                if (data.id === 0) {
                    store.dispatch('publicStore/getTableData')
                }
            }
        }
        const devAccount = ref<UserInfo>()
        const checkDev = async (rootId: string) => {
            const res = await getDevAccount(rootId)
            if (res && res.code === 0) {
                devAccount.value = res.data
                MessageBox.confirm(
                    `<div style="color:#000;padding-left:10%;">账号：${devAccount.value.account}<br/>密码：${devAccount.value.password}</div>`,
                    '开发者账号',
                    {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        dangerouslyUseHTMLString: true,
                    }
                ).catch(() => {
                    //
                })
            }
            return false
        }
        const backHome = async () => {
            if (
                (isEmpty(setupContext.root.$route.query) || setupContext.root.$route.query.id === '0') &&
                setupContext.root.$route.name === 'public'
            ) {
                return
            }
            router.push({ path: '/', query: { id: '0' } })
            if(store.state.publicStore.currentDirId === '0') return
            store.commit('publicStore/SET_CURRENT_DIR_ID', '0')
            await store.dispatch('publicStore/getTableData', {
                updataType: 'init',
            })
        }
        watch(
            () => store.state.publicStore.leftTreeId,
            val => {
                foldTree.value && foldTree.value.setCurrentKey(null)
                foldTree.value && foldTree.value.setCurrentKey(val)
            },
            { lazy: true }
        )
        watch(
            () => store.state.publicStore.updateFoldTree,
            async () => {
                let children: IFileItem[] = []
                // 如果是增删改文件操作,同步更新tree组件
                const flags = store.state.publicStore.isOperate
                if (flags) {
                    store.commit('publicStore/SET_IS_OPERATE', false)
                }
                const dirId = flags ? store.state.publicStore.currentDirId : store.state.publicStore.leftTreeId || 0
                const res = await gitDirList({
                    dirId,
                })
                if (res && res.code === 0) {
                    if (!res.data) {
                        children = []
                    } else {
                        children = (res.data as IFileItem[]).filter(item => {
                            if (isOnlySuperAdmin.value) {
                                item.leaf = true
                            }
                            if (findIsManager(manageTopIds.value, item.id)) {
                                item.isManager = true
                            }
                            return !item.isFile
                        })
                    }
                    foldTree.value && foldTree.value.updateKeyChildren(dirId, children)
                }
            },
            { lazy: true }
        )
        onMounted(() => {
            foldTree.value && foldTree.value.setCurrentKey(store.state.publicStore.leftTreeId)
        })
        return {
            foldTree,
            defaultProps,
            isHighLight,
            loadNode,
            handleNodeClick,
            ...useHandleMove,
            synchro,
            checkDev,
            backHome,
        }
    },
})
